export const ERROR_MESSAGES = {
  REQUIRED: 'Пожалуйста, заполните поле',
  NUMBER: 'Поле только для цифр',
  NUMBER_INT: 'Поле только для целых цифр',
  NUMBER_DECIMAL: 'Поле только для чисел с двумя цифрами после запятой',
  EMAIL: 'Некорректный email',
  PERSONAL_INFO: 'Для продолжения необходимо согласие',
  PHONE: 'Некорректный телефон',
  TELEGRAM: 'Никнейм в telegram должен соответствовать @nickname',
  STRING_MIN: 'Необходимо ввести не менее %s символов',
  STRING_MAX: 'Необходимо ввести не более %s символов',
};
